exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".output-package-selector {\n  width: unset !important;\n  min-width: 300px;\n}\n", ""]);

// exports
